export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/logo-laposte.d0672881.svg","height":78,"width":181,"blurWidth":0,"blurHeight":0};